import {
  GET_RESERVATIONLIST,
  GET_ADDRESERVATION,
  GET_UPDATERESERVATION,
  GET_RESERVATIONDETAILS,
  GET_BOOKINGREPORTDOWNLOAD,
  GET_CANCELREASON,
  GET_BOOKINGBUFFERTIME,
  GET_AIRPORTTERMINALLIST
} from 'resources/actionTypes';

const initialReservationListState = {
  loading: false,
  error: null,
  reservationList: '',
};

const initialReservationDetailsState = {
  loading: false,
  error: null,
  reservationDetails: '',
};

const initialState = {
  loading: false,
  error: null,
  bookingResponse: '',
};

const initialUpdateReservation = {
  loading: false,
  error: null,
  updateReservation: '',
};

const initialDownload = {
  loading: false,
  error: null,
  downloadReport: '',
}

const initialCancelReasonState = {
  loading: false,
  error: null,
  cancelReason: '',
};

const initialBookingBufferTimeState = {
  loading: false,
  error: null,
  bufferTime: '',
}

const initialAirportTerminalsState = {
  loading: false,
  error: null,
  airportTerminalList: '',
}

export const getReservationList = (
  state = initialReservationListState,
  action
) => {
  switch (action.type) {
    case GET_RESERVATIONLIST.GET_RESERVATIONLIST_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case GET_RESERVATIONLIST.GET_RESERVATIONLIST_SUCCESS:
      return {
        ...state,
        loading: false,
        reservationList: action.reservationList,
      };
    case GET_RESERVATIONLIST.GET_RESERVATIONLIST_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };
    default:
      return state;
  }
};

export const getReservationDetails = (
  state = initialReservationDetailsState,
  action
) => {
  switch (action.type) {
    case GET_RESERVATIONDETAILS.GET_RESERVATIONDETAILS_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case GET_RESERVATIONDETAILS.GET_RESERVATIONDETAILS_SUCCESS:
      return {
        ...state,
        loading: false,
        reservationDetails: action.reservationDetails,
      };
    case GET_RESERVATIONDETAILS.GET_RESERVATIONDETAILS_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };
      case GET_RESERVATIONDETAILS.CLEAR_RESERVATIONDETAILS:
        return {
          ...state,
          loading: false,
          reservationDetails: "",
        };
    default:
      return state;
  }
};

export const addReservation = (state = initialState, action) => {
  switch (action.type) {
    case GET_ADDRESERVATION.GET_ADDRESERVATION_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case GET_ADDRESERVATION.GET_ADDRESERVATION_SUCCESS:
      return {
        ...state,
        loading: false,
        bookingResponse: action.addReservationList,
      };
    case GET_ADDRESERVATION.GET_ADDRESERVATION_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };
    default:
      return state;
  }
};

export const updateReservation = (state = initialUpdateReservation, action) => {
  switch (action.type) {
    case GET_UPDATERESERVATION.GET_UPDATERESERVATION_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case GET_UPDATERESERVATION.GET_UPDATERESERVATION_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case GET_UPDATERESERVATION.GET_UPDATERESERVATION_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };
    default:
      return state;
  }
};


export const getDownLoadList = (
  state = initialDownload,
  action
) => {
  switch (action.type) {
    case GET_BOOKINGREPORTDOWNLOAD.GET_BOOKINGREPORTDOWNLOAD_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case GET_BOOKINGREPORTDOWNLOAD.GET_BOOKINGREPORTDOWNLOAD_SUCCESS:
      return {
        ...state,
        loading: false,
        downloadData: action.downloadReport,
      };
    case GET_BOOKINGREPORTDOWNLOAD.GET_BOOKINGREPORTDOWNLOAD_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };
    default:
      return state;
  }
};

export const getCancelReason = (
  state = initialCancelReasonState,
  action
) => {
  switch (action.type) {
    case GET_CANCELREASON.GET_CANCELREASON_REQUESTED:
      return {
        ...state,
        loading: true,
      };
    case GET_CANCELREASON.GET_CANCELREASON_SUCCESS:
      return {
        ...state,
        loading: false,
        cancelReason: action.cancelReason,
      };
    case GET_CANCELREASON.GET_CANCELREASON_FAILED:
      return {
        ...state,
        loading: false,
        error: action.message,
      };
    default:
      return state;
  }
};

export const getBookingBufferTime = (state = initialBookingBufferTimeState, action) => {
  switch (action.type) {
    case GET_BOOKINGBUFFERTIME.GET_BOOKINGBUFFERTIME_REQUESTED:
      return {
        ...state,
        loading: true,
      };
      case GET_BOOKINGBUFFERTIME.GET_BOOKINGBUFFERTIME_SUCCESS:
        return {
          ...state,
          loading: false,
          bufferTime: action.bufferTime,
        };
      case GET_BOOKINGBUFFERTIME.GET_BOOKINGBUFFERTIME_FAILED:
        return {
          ...state,
          loading: false,
          error: action.message,
        };
        default:
          return state;
      }
}

export const getAirportTerminalList = (state = initialAirportTerminalsState, action) => {
  switch (action.type) {
    case GET_AIRPORTTERMINALLIST.GET_AIRPORTTERMINALLIST_REQUESTED:
      return {
        ...state,
        loading: true,
      };
      case GET_AIRPORTTERMINALLIST.GET_AIRPORTTERMINALLIST_SUCCESS:
        return {
          ...state,
          loading: false,
          airportTerminalList: action.airportTerminalsDetails,
        };
      case GET_AIRPORTTERMINALLIST.GET_AIRPORTTERMINALLIST_FAILED:
        return {
          ...state,
          loading: false,
          error: action.message,
        };
        default:
          return state;
      }
}